import type { CurrencyCode } from 'apis/handler/exchange-rate';
import { create } from 'zustand';
import { StorageValue, persist } from 'zustand/middleware';

export const CURRENCY_STORE_KEY = 'currency-store';

type CurrencyState = {
  // 'KRW' = 외화 표시 안 함 (기본)
  selectedCurrency: CurrencyCode;
  setSelectedCurrency: (code: CurrencyCode) => void;
};

export const useCurrencyStore = create(
  persist<CurrencyState>(
    (set) => ({
      selectedCurrency: 'KRW',
      setSelectedCurrency: (code) => set({ selectedCurrency: code }),
    }),
    {
      name: CURRENCY_STORE_KEY,
      storage: {
        getItem: (key): StorageValue<CurrencyState> | null => {
          const value = localStorage.getItem(key);
          return value ? JSON.parse(value) : null;
        },
        setItem: (key, value) => {
          localStorage.setItem(key, JSON.stringify(value));
        },
        removeItem: (key) => {
          localStorage.removeItem(key);
        },
      },
    },
  ),
);
